import { Component, OnInit, TemplateRef, Inject, Input, Output, ViewEncapsulation, ViewChild } from '@angular/core';

import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import { formatDate } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { DatePipe } from '@angular/common';

import { GestockService } from '../services/gestock.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-histostocks',
  templateUrl: './histostocks.component.html',
  styleUrls: ['./histostocks.component.css']
})
export class HistostocksComponent implements OnInit {



  samacaabiyoonwii: any;
  porteeUser = "";
  profil = "";

  alltypedepenses = [];

  retourClientWS: any;

  dataSource: MatTableDataSource<any>;

  displayedColumns: string[] = ['datecreat', 'description', 'categorie', 'montant', 'nomlieudepense', 'debperiode', 'finperiode'];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  filteredData: any;

  nbrePrdAjust = 0;
  totalEcart = 0;
  totalValeurMonEcart = 0;

  boutiques = []; //string[] = ['Toutes', 'Boutique A', 'Boutique B'];
  selectedBoutique: string = 'Toutes';

  mvtDeStockChoisi: any;

  mvtStockDetails = [];

  @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;
  spinnerDialogRef: any;

  @ViewChild('detailMvtStockDialog') detailMvtStockDialog: TemplateRef<any>;
  detailMvtStockDialogRef: any;


  sourceBoutique: any;
  destinationBoutique: any;

  datedeb: any;
  datefin: any;

  mvtDeStockYi = [];

  mvtDeStockYiOriginal = [];

  constructor(private dialog: MatDialog, private configServer: GestockService, private snackBar: MatSnackBar) {
  }


  ngOnInit(): void {
    this.datedeb = new Date();
    this.datefin = new Date();
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii");
    this.porteeUser = sessionStorage.getItem("portee");
    this.profil = sessionStorage.getItem("profil");
    this.getAllPoints();
  }

  isAdmin(): boolean {
    return this.profil === "ADMINISTRATEUR";
  }

  envoyerTransfert() {
/*    const transfert = {
      source: this.sourceBoutique.id,
      destination: this.destinationBoutique.id,
      articles: this.articles
        .filter(a => a.qteTransfert > 0)
        .map(a => ({ id: a.id, qte: a.qteTransfert }))
    };
*/  }



  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.mvtDeStockYi = this.mvtDeStockYiOriginal.filter(item => {
      for (const key in item) {
        if (item[key] && item[key].toString().toLowerCase().includes(filterValue)) {
          return true;
        }
      }
      return false;
    });
  }

  afficheHeureOperatoion(dateOperation) {

    const dateString = dateOperation;

    // Séparer manuellement la date et l'heure
    const [datePart, timePart] = dateString.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hours, minutes, seconds] = timePart.split(":").map(Number);

    // Créer l'objet Date
    const date = new Date(year, month - 1, day, hours, minutes, seconds);

    // Extraire l'heure
    const hh = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    const mm = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    const ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

    return `${hh}:${mm}:${ss}`;  // Heure exacte : 15:04:10

  }



  getAllPoints() {

    this.configServer.getAllPoints(this.samacaabiyoonwii).then((retourbi) => {
      this.retourClientWS = retourbi;
      var statutreq = this.retourClientWS.statutreq;
      if (statutreq == 1) {
        console.log("Done");
        this.boutiques = this.retourClientWS.data;
        if (this.boutiques.length == 1)
          this.selectedBoutique = this.boutiques[0].idPoint;
        this.getAllRapportsStock();
      }
      else {
        console.log("Failed");
      }
    });
  }

  onBoutiqueChange(): void {
    this.getAllRapportsStock();
  }


  getDateFormatFrench(datebi) {
    if (datebi != undefined) {
      let datebiDoug = new Date(datebi);
      let weerwi = datebiDoug.toLocaleString('fr-FR', { month: 'long' });
      let jourBi = datebiDoug.getDate();
      let anneeBi = datebiDoug.getFullYear();
      return jourBi + " " + weerwi + " " + anneeBi;
    } else
      return "";
  }



  getAllRapportsStock() {
    console.log(this.datedeb, this.datefin);
    var debut = formatDate(this.datedeb, "yyyy-MM-dd", 'en-US');
    var fin = formatDate(this.datefin, "yyyy-MM-dd", 'en-US');

    //this.openSpinnerDialog() ;
    this.configServer.getAllRapportsStock(this.samacaabiyoonwii, this.selectedBoutique, debut, fin).then((retourbi) => {
      //this.closeSpinnerDialog() ;
      this.retourClientWS = retourbi;
      var statutreq = this.retourClientWS.statutreq;

      if (statutreq == 1) {
        this.mvtDeStockYi = this.retourClientWS.data;
        this.mvtDeStockYiOriginal = this.mvtDeStockYi;
        console.log("Done");
      }
      else {
        console.log("Failed");
      }
    });
  }

  getMontantFormatee(montant) {
    let resultd = Number(montant).toLocaleString('fr-FR');
    return resultd;
  }

  getDetailMvtStock(benMvtDeStock) {
    this.mvtDeStockChoisi = benMvtDeStock;
    this.mvtStockDetails = JSON.parse(benMvtDeStock.infosentrees);
    this.opendetailMvtStockDialog()
  }


  getInfosUSer(infosuser) {
    console.log(infosuser);
    let theObjt = JSON.parse(infosuser);
    return theObjt.prenom + " " + theObjt.nom;
  }

  getChiffreGlobaux() {

    this.nbrePrdAjust = 0;
    this.totalEcart = 0;
    this.totalValeurMonEcart = 0;

    for (var i = 0; i < this.mvtStockDetails.length; i++) {

      const lArtticle = this.mvtStockDetails[i];
      const ecart = Number(lArtticle.ecart);

      if (ecart != 0) {
        this.nbrePrdAjust++;
        this.totalEcart += ecart;
        this.totalValeurMonEcart += Number(lArtticle.valeurEcart);
      }


    }
  }

  getDepotAffiche(nomdepot) {
    if (nomdepot == "all")
      return "Tous Les Dépôts";
    else
      return nomdepot;
  }

  deleteStockEntry() {
    if (confirm('Êtes-vous sûr de vouloir supprimer cette entrée de stock ? Cette action est irréversible.')) {
      this.openSpinnerDialog();
      this.configServer.deleteStockEntry(this.samacaabiyoonwii, this.mvtDeStockChoisi.id).then((retourbi) => {
        this.closeSpinnerDialog();
        this.retourClientWS = retourbi;
        var statutreq = this.retourClientWS.statutreq;
        if (statutreq == 1) {
          this.snackBar.open('Entrée de stock supprimée avec succès', 'Fermer', {
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
          });
          this.closedetailMvtStockDialog();
          this.getAllRapportsStock(); // Rafraîchir la liste
        } else {
          this.snackBar.open('Erreur lors de la suppression: ' + this.retourClientWS.message, 'Fermer', {
            duration: 5000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
          });
        }
      });
    }
  }

  opendetailMvtStockDialog() {
    this.detailMvtStockDialogRef = this.dialog.open(this.detailMvtStockDialog, {
      height: 'auto', // or use 'auto'
      maxHeight: '90vh',
    });
  }

  closedetailMvtStockDialog() {
    this.detailMvtStockDialogRef.close();
  }


  exportToExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.mvtStockDetails.map(item => ({
      Produit: item.nom,
      Quantité: item.qte,
      'Prix Entrée': item.prix_entree,
      'Valeur Totale': item.qte * item.prix_entree
    })));

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Details_Mouvement_Stock');

    const fileName = `Details_Stock_${this.mvtDeStockChoisi.nomoperation}_${formatDate(new Date(), 'yyyyMMdd_HHmmss', 'en-US')}.xlsx`;
    XLSX.writeFile(wb, fileName);
  }

  getTotalValue(item: any): number {
    return item.qte * item.prix_entree;
  }

  getMvtTotalValue(): number {
    return this.mvtStockDetails.reduce((acc, item) => acc + (item.qte * item.prix_entree), 0);
  }

  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }


}
